const reviews = [
  { name: 'Mehmet Yılmaz', area: 'Beylikdüzü', rating: 5, text: 'Gece 02:00\'de kapım kilitli kaldı. 12 dakikada geldiler ve hiç hasar vermeden açtılar. Çok teşekkürler!' },
  { name: 'Ayşe Kaya', area: 'Esenyurt', rating: 5, text: 'Çelik kapımın kilidi bozulmuştu. Hem açtılar hem de yeni kilit taktılar. Fiyat çok uygundu, kesinlikle tavsiye ederim.' },
  { name: 'Hasan Demir', area: 'Büyükçekmece', rating: 5, text: 'Araç anahtarımı kaybettim, oto çilingir hizmeti aldım. Çok hızlı ve profesyoneldi. Teşekkürler Alfa Çilingir!' },
  { name: 'Fatma Şahin', area: 'Bahçeşehir', rating: 5, text: 'Kiracım çıkarken kilidi değiştirmek istedim. Aynı gün geldiler, kaliteli kilit taktılar. Harika hizmet!' },
  { name: 'Ali Çelik', area: 'Beylikdüzü Gürpınar', rating: 5, text: 'Ofis kasasının şifresini unutmuştum. Çok kısa sürede açtılar, şifreyi sıfırladılar. Profesyonel ekip.' },
  { name: 'Zeynep Arslan', area: 'Esenyurt Fatih', rating: 5, text: 'Komşuma tavsiye ettim, o da çok memnun kaldı. Güvenilir, hızlı ve uygun fiyatlı. Alfa Çilingir\'i herkese öneririm.' },
];

export default function Testimonials() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-orange-500 text-xs font-bold uppercase tracking-widest mb-3">
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-star-fill"></i></span>
            Müşteri Yorumları
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">
            Müşterilerimiz Ne Diyor?
          </h2>
          <div className="flex items-center justify-center gap-1 mb-2">
            {[1,2,3,4,5].map(i => (
              <span key={i} className="w-5 h-5 flex items-center justify-center text-orange-400">
                <i className="ri-star-fill text-lg"></i>
              </span>
            ))}
            <span className="ml-2 text-gray-500 text-sm">4.9/5 — 200+ Değerlendirme</span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((r) => (
            <div key={r.name} className="bg-stone-50 rounded-2xl p-6 border border-stone-100">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: r.rating }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center text-orange-400">
                    <i className="ri-star-fill text-sm"></i>
                  </span>
                ))}
              </div>
              <p className="text-gray-700 text-sm leading-relaxed mb-4">"{r.text}"</p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center bg-orange-100 text-orange-600 rounded-full font-bold text-sm">
                  {r.name.charAt(0)}
                </div>
                <div>
                  <p className="font-semibold text-gray-900 text-sm">{r.name}</p>
                  <p className="text-gray-400 text-xs">{r.area}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
